import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { createSpot } from '../../store/slices/savedLocationsSlice';
import Header from '../../layout/Header'
import MobileNav from '../../layout/MobileNav'
import PageNavLocation from '../../layout/PageNavLocation';
import Input from '../../components/fields/Input';
import ButtonLightBlue from '../../components/buttons/ButtonLightBlue';
import {Helmet} from "react-helmet";

const SpotSave = () => {
    const [location, setLocation] = useState(null);
    const { isLoading, errors, currentSpot } = useSelector(state => state.savedLocations);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    React.useEffect(() => {
        // Fetch coordinates from url querystring
        const params = new URLSearchParams(window.location.search);
        const lat = params.get('lat');
        const lon = params.get('lon');
        setLocation({ lat, lon });
    }, [dispatch]);

    React.useEffect(() => {
        if(currentSpot.id){
            navigate(`/location/${currentSpot.id}/view`);
        }
    }, [currentSpot.id, navigate]);

    const [formData, setFormData] = useState({
        name: ''
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleOnSubmit = async (e) => {
        e.preventDefault();
        
        const spotData = {
            name: formData.name,
            latitude: location.lat,
            longitude: location.lon
        };

        try {
          
            const result = await dispatch(createSpot(spotData)).unwrap();
            
            console.log('Spot saved successfully:', result);
            // navigate('/'); 

        } catch (error) {
            console.error('Failed to save spot:', error);
        }
    };

    if(!location) {
        return <></>;
    }

    return (
      <>
        <Helmet>
            <title>Save Spot | Oreca Pro</title>
            <link rel="canonical" href={window.location.href} />
        </Helmet>
        <Header />
        <MobileNav />
        <div className='py-[80px] px-5 max-w-[1100px] mx-auto'>

          <h1 className='text-2xl font-semibold mb-2 md:mt-8'>Current Spot</h1>

          <p className='text-xs text-custom-light-grey'>
              {Number(location.lat).toFixed(2)}, {Number(location.lon).toFixed(2)}
          </p>

          {/* page nav */}
          <PageNavLocation location={location} />

          <form onSubmit={handleOnSubmit} className='max-w-[400px] mx-auto mt-10'>
                {errors && (
                    <div style={{ color: 'red', marginBottom: '10px' }}>
                        {Object.values(errors).map((error, index) => (
                            <div key={index}>{error}</div>
                        ))}
                    </div>
                )}

                <h2 className="text-xl font-semibold mb-6 text-white">Save Spot</h2>

                <Input 
                  type="text" 
                  name="name" 
                  value={formData.name}
                  placeholder="Name this spot"
                  onChange={handleInputChange}
                  required
                />
            
            <ButtonLightBlue 
              type="submit" 
              text={isLoading ? 'Saving...' : 'Save Spot'}
            />
          </form>
          
      </div>
      </>
    )
};

export default SpotSave;
